import { css } from 'styled-components';
import { lightGlobalTokens, darkGlobalTokens } from './colorGlobal';
import { colorAliasTokens } from './colorAlias';
import { borderRadiusTokens } from './borderRadius';
import { spacingTokens } from './spacing';
import { typographyTokens } from './typography';
import { zIndexTokens } from './zIndex';
import { elevationTokens } from './elevation';
import { motionTokens } from './motion';

const colorTokens = css`
  ${lightGlobalTokens}
  /* Dark mode is disabled until we have a more robust plan for supporting it */

  /* @media (prefers-color-scheme: dark) {
    ${darkGlobalTokens}
  } */
  ${colorAliasTokens}
`;

export const designTokens = css`
  :root,
  [data-wui-theme='true'] {
    ${borderRadiusTokens}
    ${colorTokens}
    ${elevationTokens}
    ${spacingTokens}
    ${typographyTokens}
    ${zIndexTokens}
    ${motionTokens}
  }
`;
